import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { Computed, Methods } from '@owc-types/ComponentInitializeDispatcher';
import { Mixin as HeaderMixin } from '@owc-types/Header';
import { BaseDataJson } from '@/packages/_types/BaseDataJSON';
import { OwcComponentMixinData } from './OwcComponent';

/**
 * This mixin allows every component to use this.componentData even if they are not using
 * the seamless registry, replacing the old usage of "this.json".
 * This allows unification and consistency across all components even if they still use the data json directly.
 *
 * This also allows the component to fully work regardless of how the component configurations are
 * passed to the FE from AEM. Creating a more decoupled approach, and reducing deploy bottlenecks between FE and BE.
 *
 * The beforeMount logic can be removed when datajson is sundown completely (end of PI 9). The dir logic can then be moved
 * to owc components for example and this file erased.
 * @keywords: REGISTRY, this.json, this.componentData
 */
const mixin: ThisTypedComponentOptionsWithRecordProps<
  Vue & Partial<HeaderMixin>,
  OwcComponentMixinData<BaseDataJson>,
  Methods,
  Computed<BaseDataJson>,
  {},
  {},
  {},
  {}
> = {
  beforeMount() {
    this.$set(this, 'componentData', {
      ...this.componentData,
      ...this.json,
    });
  },
  mounted() {
    const currentDir = this.$el.ownerDocument?.querySelector('html')?.getAttribute('dir') || 'ltr';

    if (this.$el instanceof HTMLElement && currentDir) {
      this.$el.setAttribute('dir', currentDir);
    }
  },
};

export default mixin;
